<script lang="ts">
  import { twMerge } from "tailwind-merge";

  export let width: number = 16;
  export let height: number = 16;
  export let color: string = "#fff";
  export let thickness: number = 3;
  let className: string = "";
  export { className as class };
</script>

<span
  {...$$restProps}
  class={twMerge("loader", className)}
  style={`
  width: ${width}px;
  height: ${height}px;
  border: ${thickness}px solid ${color};
  border-bottom-color: transparent;
  ${$$restProps.style}
`}
></span>

<style>
  .loader {
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
